// extracted by mini-css-extract-plugin
export default {"root":"IconFestival_root__WD689"};